export const getParamsType = (o) => {
    return Object.prototype.toString
        .call(o)
        .slice(8, -1)
        .toLowerCase();
};
export const isValidObject = (o) => {
    return getParamsType(o) === 'object' && Object.keys(o).length;
};
